// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3WTak","label":"SetPasswdForm_label__12PJL"};